import React, { useState, useRef, useEffect } from "react";
import { FaShareAlt, FaRegCopy } from "react-icons/fa";
import { ImageLink } from "../../../constants";
import { dateFormat } from "../../dashboard/dateFormat";
import { useNavigate } from "react-router-dom";
import "./BlogCard.scss";
const BlogCard = ({ data }) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  const popupRef = useRef(null);
  const blogUrl = `${window.location.origin}/blogs/${data.url}`;
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
        setCopied(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleCopy = () => {
    navigator.clipboard.writeText(blogUrl);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  const handleredirect = () => {
    navigate(`/blogs/${data.url}`, { state: { data } });
  };

  return (
    <div className="blogCardContainer">
      <div onClick={handleredirect} className="blogCardLink">
        <div className="blogCard">
          <div className="blogImage">
            <img src={ImageLink(data.coverImage)} alt={data.title} />
          </div>

          <div className="blogContent">
            <h3>{data.title}</h3>
            <div className="blogFooter">
              <span>{data?.updatedAt && dateFormat(data?.updatedAt)}</span>

              <div
                className="shareBtn"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowPopup((prev) => !prev);
                }}
              >
                <FaShareAlt />
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="shareDropdownPopup" ref={popupRef}>
          <div className="popupContent">
            <div className="popupUrlContainer">
              <span className="popupUrl" title={blogUrl}>
                {blogUrl}
              </span>
              <div className="copyWrapper">
                <FaRegCopy className="copyIcon" onClick={handleCopy} />
                {copied && <span className="copiedTooltip">Copied!</span>}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogCard;
